'use client'

import React from 'react'
import { CheckCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import type { BookingData } from '@/types/booking'

interface StepSelectedDoctorBannerProps {
  bookingData: BookingData
  onChangeDoctor: () => void
}

const StepSelectedDoctorBanner: React.FC<StepSelectedDoctorBannerProps> = ({
  bookingData,
  onChangeDoctor,
}) => {
  if (!bookingData.doctorID || !bookingData.doctorName) return null

  return (
    <Card className="mb-4 border-blue-100 bg-blue-50/70 p-3 shadow-sm sm:mb-5 sm:p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
            <CheckCircle className="h-5 w-5 text-blue-600" />
          </div>

          <div className="min-w-0">
            <p className="text-xs font-medium text-blue-700">
              Selected clinician
            </p>
            <p className="truncate text-sm font-semibold text-gray-900 sm:text-base">
              {bookingData.doctorName}
            </p>
          </div>
        </div>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onChangeDoctor}
          className="shrink-0 rounded-full"
        >
          Change
        </Button>
      </div>
    </Card>
  )
}

export default StepSelectedDoctorBanner
